import Model from '@models/Model'
import Issue from "@models/Issue"
import User from '@models/User'

class IssueActivityItem extends Model {
  constructor (initialData, included) {
    super(initialData, included, {
      columns: [
        'id',
        'category',
        'comment_text',
        'state_change_text',
        'created_by_id',
        'issue_id',
        'created_at',
        'updated_at',
        'discarded_at',
      ],
      dateKeys: [
        'created_at',
        'updated_at',
        'discarded_at',
      ],
      relationships: {
        issue: { collection: false, model: Issue },
        created_by: { collection: false, model: User },
      },
    })
  }
}

export default IssueActivityItem